export default __webpack_public_path__ + "024028387f2ea944bdf8c2156ebe84c4.png";